// // components/FlowSelect.jsx
import React, { useState, useEffect, useCallback } from 'react';

const FlowSelect = ({ onFlowSelect }) => {
  const [flowCategories, setFlowCategories] = useState([]);
  const [selectedFlow, setSelectedFlow] = useState(null);

  // Fetch available flows from the public folder
  useEffect(() => {
    const fetchFlows = async () => {
      try {
        const response = await fetch('/flows/flows-index.json'); // Path to the index file
        const data = await response.json();
        setFlowCategories(data);
      } catch (error) {
        console.error('Error fetching flow:', error);
      }
    };

    fetchFlows();
  }, []);

  // Handle flow selection
  const handleChange = useCallback((event) => {
    const flowPath = event.target.value;
    
    // Find the selected flow object to get its name
    if (flowPath) {
      let selectedFlowObj = null;
      
      // Search through all categories to find the matching flow
      for (const category of flowCategories) {
        const flow = category.flows.find(f => f.path === flowPath);
        if (flow) {
          selectedFlowObj = flow;
          break;
        }
      }
      
      // Update the selected flow state
      setSelectedFlow(selectedFlowObj);
      
      // Call the parent's callback
      if (onFlowSelect) {
        onFlowSelect(flowPath);
      }
    } else {
      setSelectedFlow(null);
    }
  }, [onFlowSelect, flowCategories]);

  return (
    <select 
      className="bg-gray-900 px-2 outline-none border-r border-gray-500 w-44 text-[0.9em]"
      onChange={handleChange}
      title={selectedFlow ? selectedFlow.name : "Select a flow"}
    >
      <option value="">Select a flow</option>
      {flowCategories.map((category, index) => (
        <optgroup key={index} label={category.category}>
          {category.flows.map((flow, flowIndex) => (
            <option key={flowIndex} value={flow.path}>{flow.name}</option>
          ))}
        </optgroup>
      ))}
    </select>
  );
};

export default FlowSelect;



// // components/FlowSelect.jsx
// import React, { useState, useEffect, useCallback } from 'react';

// const FlowSelect = ({ onFlowSelect }) => {
//   const [flowCategories, setFlowCategories] = useState([]);

//   // Fetch available flows from the public folder
//   useEffect(() => {
//     const fetchFlows = async () => {
//       try {
//         const response = await fetch('/flows/flows-index.json'); // Path to the index file
//         const data = await response.json();
//         setFlowCategories(data);
//       } catch (error) {
//         console.error('Error fetching flow:', error);
//       }
//     };


//     fetchFlows();
//   }, []);

//   // Handle flow selection
//   const handleChange = useCallback((event) => {
//     const flowPath = event.target.value;
//     if (flowPath && onFlowSelect) {
//       onFlowSelect(flowPath);
//     }
//   }, [onFlowSelect]);

//   return (
//     <select className="bg-gray-900 px-2 outline-none border-r border-gray-500 w-44 text-[0.9em]"
//       onChange={handleChange}
//       title={flow.name}
//     >
//       <option value="">Select a flow</option>
//       {flowCategories.map((category, index) => (
//         <optgroup key={index} label={category.category}>
//           {category.flows.map((flow, flowIndex) => (
//             <option key={flowIndex} value={flow.path}>{flow.name}</option>
//           ))}
//         </optgroup>
//       ))}
//     </select>
//   );
// };

// export default FlowSelect;